import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface TreemapNode {
  name: string;
  value?: number;
  children?: TreemapNode[];
}

interface TreemapChartProps {
  data: TreemapNode[];
  height?: number | string;
  loading?: boolean;
}

export function TreemapChart({ data, height, loading }: TreemapChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    series: [{ type: 'treemap', data, roam: 'scale', upperLabel: { show: true, height: 30 }, label: { show: true }, breadcrumb: { show: false } }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
